import * as React from 'react';
import { palette } from '../../../constants';
import { DotSolid } from '../../../icons';
export function useAppearance(appearance, fill, color) {
    switch (appearance) {
        case 'accent':
            return {
                $background: palette.pureWhite,
                $border: "1px solid " + palette.neutral3,
                $color: color !== undefined ? palette[color] : palette.pureBlack,
                Before: fill !== undefined ? (React.createElement(DotSolid, { fillColor: palette[fill], tiny: true })) : undefined
            };
        case 'plain':
            return {
                $background: palette.pureWhite,
                $border: "1px solid " + palette.neutral3,
                $color: color !== undefined ? palette[color] : palette.pureBlack
            };
        case 'solid':
            return {
                $background: fill !== undefined ? palette[fill] : palette.neutral5,
                $color: color !== undefined ? palette[color] : palette.pureWhite
            };
        default:
            return {
                $background: palette.pureWhite,
                $border: "1px solid " + palette.neutral3,
                $color: palette.pureBlack
            };
    }
}
//# sourceMappingURL=useAppearance.js.map